import OpinionSliderSection from "./sections/opinionSliderSection";

export default function swiperSliders() {
    const opinions = document.querySelectorAll('[data-opinion-slider]')
    opinions.forEach(slider => new OpinionSliderSection(slider));
}